import { LocalAuthority, Account, LocalAuthorityChapterAccount} from '../../model'
import { genericFetch }  from './common-service'
import { getBaseHeader } from "./utils"
import { apiBaseUrl }    from "./config"
import ApiError, { ApiErrorCode }      from "../../error/api-error"
import { createLacaUpdateRequestBody, createLacaRequestBody } from './factory';

const LOCALAUTHORITIES = 'localauthorities'
const LACAS = 'lacas'

export function createLaca(
	localAuthority: LocalAuthority,
	laca          : LocalAuthorityChapterAccount
): Promise<LocalAuthorityChapterAccount> {
	const lacaRB = createLacaRequestBody(laca)
	const body = JSON.stringify(lacaRB)
	const url  = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${LACAS}`
	const init = {
		body,
		headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
		method: "POST"
	} as RequestInit

	return fetch(url, init).then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(result => result as LocalAuthorityChapterAccount)
			case 404:
				throw new ApiError(ApiErrorCode.NotFound, "Le compte de cette collectivité n'existe pas.")
			case 409:
				throw new ApiError(ApiErrorCode.Conflict, "Le compte pour cette collectivité existe déjà.")
		}
		throw new Error("Unexpected error.")
	})
}

export function deleteLaca(localAuthority: LocalAuthority, account: Account): Promise<void> {
	const url: string = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${LACAS}/${account.id}`
	return genericFetch<void>(url, { headers: getBaseHeader(), method: "DELETE" })
}

export function updateLaca(localAuthority: LocalAuthority, laca: LocalAuthorityChapterAccount): Promise<LocalAuthorityChapterAccount> {
	const url: string = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${LACAS}/${laca.account.id}`
	const lacaRB = createLacaUpdateRequestBody(laca)
	const headers: HeadersInit = {
		...getBaseHeader(),
		"Content-Type": "application/json"
	}
	const body: string = JSON.stringify(lacaRB)
	const init: RequestInit = {
		body,
		headers,
		method: "PUT"
	}
	return genericFetch<LocalAuthorityChapterAccount>(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/lacas-service.ts